// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { formActions, mergeActionsToProps } from 'redux-pure-form';
import { newDate, getTimestamp, getBrowserOffset, formatDate } from '../calendar.model.js';
import Datepicker from '../../common/datepicker/datepicker';
import { checkEventParams } from '../calendar-day.actions.js';

class CustomFields extends React.Component {
  static footer = true;

  constructor(props) {
    super(props);
    this.timer = null;
    this.handleCustomFieldsDateChange = this.handleCustomFieldsDateChange.bind(this);
    this.handleCustomFieldChange = this.handleCustomFieldChange.bind(this);
  }

  componentWillMount() {
    const form = this.props[this.props.formName];
    if (!form.customFields) return null;
    Object.keys(form.customFields).forEach(field => {
      if (this.props.customFields[field] && this.props.customFields[field].type === 'date') {
        this.handleCustomFieldsDateChange(form.customFields[field], field, false);
      }
    });
  }

  componentWillUnmount() {
    if (this.timer) {
      window.clearTimeout(this.timer);
    }
  }

  handleCustomFieldsDateChange(val, fieldID, checkParams = true) {
    this.props.fieldAttrs.onChange(
      `${this.props.formName}.customFields.${fieldID}`,
      val ? val.toString() : ''
    );
    return checkParams && this.props.checkParams && this.props.checkEventParams();
  }

  handleCustomFieldChange(e) {
    const { name, value } = e.currentTarget;
    this.props.fieldAttrs.onChange(name, value);
    if (this.timer) {
      window.clearTimeout(this.timer);
    }
    this.timer = window.setTimeout(
      this.props.checkParams ? this.props.checkEventParams : null,
      300
    );
    return true;
  }

  render() {
    const { customFields, formName, user, className = '' } = this.props;

    const form = this.props[formName];

    if (!form.customFields) return null;

    return (
      <div className={className}>
        {Object.keys(form.customFields).length
          ? Object.keys(form.customFields).map(fieldID => {
              const required = customFields[fieldID].required === '1';
              const value = form.customFields[fieldID];

              return (
                <div key={fieldID} className="form-group">
                  <label
                    className={customFields[fieldID].required === '1' ? 'required-label' : ''}
                    htmlFor={fieldID}
                  >
                    {customFields[fieldID].name}
                  </label>
                  {customFields[fieldID].type === 'numeric' ? (
                    <input
                      id={fieldID}
                      type="text"
                      pattern="\d*\.?\d*"
                      title="Enter a number"
                      className="form-control"
                      name={`${formName}.customFields.${fieldID}`}
                      value={value || ''}
                      required={required}
                      onChange={this.handleCustomFieldChange}
                    />
                  ) : null}
                  {customFields[fieldID].type === 'text' ? (
                    <textarea
                      id={fieldID}
                      type="number"
                      rows="4"
                      className="form-control"
                      value={value || ''}
                      required={required}
                      name={`${formName}.customFields.${fieldID}`}
                      onChange={this.handleCustomFieldChange}
                    />
                  ) : null}
                  {customFields[fieldID].type === 'date' ? (
                    <Datepicker
                      autoComplete="off"
                      id={fieldID}
                      required={required}
                      className="form-control inner-datepicker"
                      onChange={val => this.handleCustomFieldsDateChange(val, fieldID)}
                      selected={value ? new Date(value) :  null}
                      dateFormat={user.settings.date}
                    />
                  ) : null}
                </div>
              );
            })
          : null}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  eventForm: state.eventForm,
  checkinForm: state.checkinForm,
  user: state.user,
  customFields: state.customFields
});

export default connect(
  mapStateToProps,
  {
    checkEventParams,
    ...formActions
  },
  mergeActionsToProps
)(CustomFields);
